<script>
    export let label = ''
    export let value = ''
    export let mono = false
    /** Apila etiqueta y valor (bloques largos, JSON, etc.) */
    export let full = false
</script>

<div class="details-field" class:details-field--full={full}>
    <dt class="details-field__label">{label}</dt>
    <dd class="details-field__value" class:is-mono={mono}>
        <slot>{value}</slot>
    </dd>
</div>
